import {
  PublicClientApplication,
  type Configuration,
  type RedirectRequest,
} from '@azure/msal-browser';

// Reads VITE_ENTRA_* from the bundler. We fail loudly at startup rather than
// lazily on first auth call — easier to spot misconfiguration in deploy.
function required(name: string): string {
  const value = import.meta.env[name as keyof ImportMetaEnv];
  if (!value || typeof value !== 'string') {
    throw new Error(`Missing required env var: ${name}`);
  }
  return value;
}

const tenantId = required('VITE_ENTRA_TENANT_ID');
const clientId = required('VITE_ENTRA_CLIENT_ID');

const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Scope for ABS REST API. Granted at login so silent token acquisition works
// for every subsequent call without re-consent.
const STORAGE_SCOPE = 'https://storage.azure.com/user_impersonation';

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest: RedirectRequest = {
  scopes: [STORAGE_SCOPE],
};

export const storageTokenRequest = {
  scopes: [STORAGE_SCOPE],
};
